import { useState, useEffect, useCallback, useRef } from 'react';

export const useWebcam = (videoRef) => {
  const [videoEnabled, setVideoEnabled] = useState(false);
  
  // FIX 1: Hold the stream in a ref so it doesn't trigger React re-renders
  const streamRef = useRef(null);

  const stopWebcam = useCallback(() => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach((track) => track.stop());
      streamRef.current = null; // Clear the ref
    }
    if (videoRef.current) {
      videoRef.current.srcObject = null;
    }
    setVideoEnabled(false);
  }, [videoRef]);

  const startWebcam = useCallback(async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      streamRef.current = stream; // Save silently to ref

      if (videoRef.current) {
        // FIX 2: Only attach the stream if it isn't already attached.
        // This completely prevents the DOMException abort error.
        if (videoRef.current.srcObject !== stream) {
          videoRef.current.srcObject = stream;
        }
      }
      setVideoEnabled(true);
    } catch (err) {
      console.error("Webcam access error:", err);
      setVideoEnabled(false);
    }
  }, [videoRef]);

  const toggleVideo = async () => {
    if (videoEnabled) {
      stopWebcam();
    } else {
      await startWebcam();
    }
  };

  // FIX 3: A passive watcher. If React DOES force a massive re-render 
  // (like going fullscreen) and wipes the DOM node, this silently puts the stream back.
  useEffect(() => {
    if (videoEnabled && videoRef.current && streamRef.current) {
      if (videoRef.current.srcObject !== streamRef.current) {
        videoRef.current.srcObject = streamRef.current;
      }
    }
  }, [videoEnabled, videoRef]);

  // Clean up hardware strictly on component unmount
  useEffect(() => {
    return () => {
      if (streamRef.current) {
        streamRef.current.getTracks().forEach((track) => track.stop());
      }
    };
  }, []);

  return { videoEnabled, toggleVideo, setupCamera: startWebcam };
};